export default "__VITE_ASSET__DCQoNGf$__"